import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Tutorial } from '../../graphql/schema/queries/tutorials'

export const viewedTutorialsQuery = gql`
  query ViewedTutorialsQuery($organizationID: ID!) {
    tutorials(organizationID: $organizationID) {
      tutorials
    }
  }
`

export function TutorialsQuery({
  organizationID,
  children
}: {
  readonly organizationID: string
  readonly children: (props: {
    readonly tutorials: Tutorial[]
  }) => React.ReactNode
}) {
  return (
    <Query query={viewedTutorialsQuery} variables={{ organizationID }}>
      {(result) => {
        const { data, error, loading } = result
        if (error) {
          throw new Error(error.toString())
        }
        if (loading) {
          return false
        }
        const { tutorials } = data.tutorials

        return children({ tutorials })
      }}
    </Query>
  )
}
